<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";
import VSelectDefaultTextWithBlockLabel from "../../Form/Survey/VSelectDefaultTextWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";

import { scrollOnError } from "@/Helpers/validation";

import intus from "intus";
import { isRequired, isRequiredIf } from "intus/rules";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination:
        answers?.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination,
    did_you_take_a_direct_or_connecting_flight_to_sabah:
        answers?.did_you_take_a_direct_or_connecting_flight_to_sabah,
    arrival_from_which_airport: answers?.arrival_from_which_airport,
    which_airline_did_you_board_on_to_enter_sabah:
        answers?.which_airline_did_you_board_on_to_enter_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(form.data(), {
        which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination:
            [isRequired()],
        did_you_take_a_direct_or_connecting_flight_to_sabah: [
            isRequiredIf(
                "which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination",
                "By Air"
            ),
        ],
        arrival_from_which_airport: [
            isRequiredIf(
                "which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination",
                "By Air"
            ),
        ],
        which_airline_did_you_board_on_to_enter_sabah: [
            isRequiredIf(
                "which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination",
                "By Air"
            ),
        ],
    });

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VRadioWithBlockLabel
                        elId="which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination"
                        v-model:value="
                            form.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination
                        "
                        :label="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="
                            form.errors
                                ?.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination
                        "
                    />
                </div>

                <template
                    v-if="
                        'By Air' ==
                        form.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination
                    "
                >
                    <div class="mb-3">
                        <VRadioWithBlockLabel
                            elId="did_you_take_a_direct_or_connecting_flight_to_sabah"
                            v-model:value="
                                form.did_you_take_a_direct_or_connecting_flight_to_sabah
                            "
                            :label="
                                surveyFields[
                                    'did_you_take_a_direct_or_connecting_flight_to_sabah'
                                ]?.name
                            "
                            :options="
                                surveyFields[
                                    'did_you_take_a_direct_or_connecting_flight_to_sabah'
                                ]?.options.map((value) => {
                                    return { id: value, description: value };
                                })
                            "
                            :error="
                                form.errors
                                    ?.did_you_take_a_direct_or_connecting_flight_to_sabah
                            "
                        />
                    </div>
                    <div class="mb-3">
                        <VSelectDefaultTextWithBlockLabel
                            elId="arrival_from_which_airport"
                            v-model:value="form.arrival_from_which_airport"
                            :label="
                                surveyFields['arrival_from_which_airport']?.name
                            "
                            :options="
                                surveyFields[
                                    'arrival_from_which_airport'
                                ]?.options.map((value) => {
                                    return { id: value, description: value };
                                })
                            "
                            :otherOptionLabel="
                                surveyFields['arrival_from_which_airport']
                                    ?.config['other_label']
                            "
                            :otherOptionPlaceholder="
                                surveyFields['arrival_from_which_airport']
                                    ?.config['other_placehholder']
                            "
                            :error="form.errors?.arrival_from_which_airport"
                        />
                    </div>
                    <div class="mb-3">
                        <VSelectDefaultTextWithBlockLabel
                            elId="which_airline_did_you_board_on_to_enter_sabah"
                            v-model:value="
                                form.which_airline_did_you_board_on_to_enter_sabah
                            "
                            :label="
                                surveyFields[
                                    'which_airline_did_you_board_on_to_enter_sabah'
                                ]?.name
                            "
                            :options="
                                surveyFields[
                                    'which_airline_did_you_board_on_to_enter_sabah'
                                ]?.options.map((value) => {
                                    return { id: value, description: value };
                                })
                            "
                            :otherOptionLabel="
                                surveyFields[
                                    'which_airline_did_you_board_on_to_enter_sabah'
                                ]?.config['other_label']
                            "
                            :otherOptionPlaceholder="
                                surveyFields[
                                    'which_airline_did_you_board_on_to_enter_sabah'
                                ]?.config['other_placehholder']
                            "
                            :error="
                                form.errors
                                    ?.which_airline_did_you_board_on_to_enter_sabah
                            "
                        />
                    </div>
                </template>
            </div>
        </div>
        <VDevider />

        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                Next
            </VButtonSubmit>
        </div>
    </div>
</template>
